import { UserStore } from '@/utils/UserStore';
import { notify } from "@kyvg/vue3-notification";

export const APIStore = {
  // APIurl: "http://localhost:8083/giselec.api/public/api/",
  ApiProxyurl: "http://localhost:3000/api/",
  APIurl: "https://accesselec.giselec.com/api/",
  // APIurl: "https://accesselec.gimsys.net/api/",

  login(login: string, password: string, isTest = false): Promise<{ success: boolean, error?: string }> {
    return fetch(this.APIurl + "auth", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify({ email: login, password: password })
    })
      .then(reponsehttp => {
        if (!reponsehttp.ok) {
          return reponsehttp.json()
            .then(reponseJSON => {
              if (!isTest) notify({ title: 'Register', text: 'Error during register', type: 'fail' });
              return { success: false, error: reponseJSON.message };
            })
        } else {
          return reponsehttp.json()
            .then(reponseJSON => {
              if (!isTest) {
                notify({ title: 'Register', text: 'Register', type: 'success' });
                const user = UserStore();
                user.setUser(reponseJSON);
              }
              return { success: true };
            })
        }
      })
  },

  logout(isTest = false): Promise<{ success: boolean, error?: string }> {
    return fetch(this.APIurl + "token/invalidate", {
      method: "POST",
      credentials: 'include',
    })
      .then(reponsehttp => {
        if (!reponsehttp.ok) {
          return reponsehttp.json()
            .then(reponseJSON => {
              return { success: false, error: reponseJSON.message };
            })
        } else {
          return reponsehttp.json()
            .then(reponseJSON => {
              if (!isTest) {
                const user = UserStore();
                user.setUser(reponseJSON);
                user.disconnect();
              }
              return { success: true };
            })
        }
      })
  },
  refresh(): Promise<{ success: boolean, error?: string }> {
    const user = UserStore();
    return fetch(this.APIurl + 'token/refresh', {
      method: "POST",
      credentials: 'include',
    })
      .then(reponsehttp => {
        if (!reponsehttp.ok) {
          return reponsehttp.json()
            .then(reponseJSON => {
              this.logout()
              return { success: false, error: reponseJSON.message };
            })
        } else {
          return reponsehttp.json()
            .then(reponseJSON => {
              const user = UserStore();
              user.setUser(reponseJSON);
              return { success: true };
            })
        }
      })
  },
  getAll(ressource: string): Promise<any> {
    return fetch(this.APIurl + ressource, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
    })
      .then(reponsehttp => reponsehttp.json())
  },
  getById(ressource: string, id: number): Promise<any> {
    return fetch(this.APIurl + ressource + '/' + id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
    })
      .then(reponsehttp => reponsehttp.json())
  },
  createRessource(ressource: string, data: any): Promise<any> {
    return fetch(this.APIurl + ressource, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
      body: JSON.stringify(data)
    })
  },
  updateRessource(ressource: string, data: any): Promise<any> {
    return fetch(this.APIurl + ressource, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include',
      body: JSON.stringify(data)
    })
      .then(reponsehttp => reponsehttp.json())
  },
  deleteRessource(ressource: string): Promise<any> {
    return fetch(this.APIurl + ressource, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include'
    })
  },
  putRessource(ressource: string, data?: any): Promise<any> {
    return fetch(this.APIurl + ressource, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: 'include'
    })
  }
}
